import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { ShipManagementCompanyPayload, ShipManagementCompanyResponse } from "@/types/interface/ship-management-company";

async function createShipManagementCompany(payload: ShipManagementCompanyPayload) {
  return await http.post<APIResponse<ShipManagementCompanyResponse>>("ship-management-company/create", payload);
}

async function updateShipManagementCompany(idPosition = '', payload: ShipManagementCompanyPayload) {
  return await http.patch<APIResponse<ShipManagementCompanyResponse>>(`ship-management-company/update?id=${idPosition}`, payload);
}

async function getShipManagementCompany(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<ShipManagementCompanyResponse>>(`ship-management-company?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findShipManagementCompany(idPosition = "") {
  return await http.get<APIResponse<ShipManagementCompanyResponse>>(`ship-management-company/detail?id=${idPosition}`);
}

async function deleteShipManagementCompany(idPosition = "") {
  return await http.delete<APIResponse<ShipManagementCompanyResponse>>(`ship-management-company/delete?id=${idPosition}`);
}

export default {
  createShipManagementCompany,
  updateShipManagementCompany,
  getShipManagementCompany,
  findShipManagementCompany,
  deleteShipManagementCompany
};